import { useContext } from 'react';
import useSelectFilter from './useSelectFilter';
import SelectFilterView from './NewSelectFilterView';
import { observer } from 'mobx-react-lite';
import { PanelFilterContext } from '../../Filters/PanelFilter/NewPanelFilter';

interface Props {
  readonly currentValue: Function;
  readonly name: string;
  readonly options: any;
  readonly label: string;
  readonly placeholder: string;
  readonly reactSelectOptions: any;
  readonly titleMode?: boolean;
  readonly menuPlacement?: string;
  readonly optionsAutosort?: boolean;
}

function SelectFilter(props: Props) {
  const { filters, setFilter } = useContext(PanelFilterContext);

  const useProps = useSelectFilter({ ...props, filters, setFilter }),
    passProps = { ...useProps };

  return <SelectFilterView {...passProps} />;
}
export default observer(SelectFilter);
